var exports = {
  "Lt": "x31de4314--196b9c--select",
  "Ld": "x31de4314--196b9c--native-select",
  "Iw": "x31de4314--196b9c--select-popup",
  "Oz": "x31de4314--196b9c--upward",
};

module.exports = exports;
